// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__ysaJt","head":"Table_head__29H8w","col":"Table_col__1ql3Y"};